<template>
  <div>
    <div class="box_bg">
      <div class="main">
        <Header style="z-index: 99" />
        <LeftNav />
        <router-view :style="height" />
      </div>
    </div>
  </div>
</template>

<script>
const name = "Layout";
import Header from "@/components/layout/header/Index";
import LeftNav from "./LeftNav.vue";
export default {
  name: name,
  data() {
    return {
      height: {
        "z-index": 97,
        width: "100%",
        height: "",
        "overflow-y": "auto",
      },
    };
  },
  methods: {
    setHeights() {
      this.height.height = window.innerHeight - 71 + "px";
    },
  },
  mounted() {
    window.onresize = () => {
      this.setHeights();
    };
    this.setHeights();
  },
  components: { Header, LeftNav },
};
</script>
<style lang="scss">
.main {
  // margin-left: 210px;
  transition: margin-left 0.3s;
  min-height: 100%;
}
.mobile {
  .main {
    margin-left: 0px;
  }
}
.main-nav-hide {
  margin-left: 0px !important;
}
.nav-hide {
  width: 0px !important;
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 100;
}
/* 组件切换动画 */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.2s;
}
.fade-transform-enter {
  opacity: 0;
  transform: translateX(-10px);
}
.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(10px);
}
</style>

